// Generated from src/data/chapters LeetCode links.
// These entries prevent course-linked problems from rendering the empty fallback page.

const courseProblems = [
  {
    "id": "3sum-closest",
    "title": "3Sum Closest",
    "difficulty": "Medium",
    "prompt": "Given an integer array nums of length n and an integer target, find three integers in nums such that the sum is closest to target. Return the sum of the three.",
    "category": "TwoPointer",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "k",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "output": 5
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "expected": 5
      }
    ]
  },
  {
    "id": "3sum-smaller",
    "title": "3Sum Smaller",
    "difficulty": "Medium",
    "prompt": "Given an array of n integers nums and an integer target, find the number of index triplets i, j, k with 0 <= i < j < k < n that satisfy the condition nums[i] + nums[j] + nums[k] <.",
    "category": "TwoPointer",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "add-two-numbers",
    "title": "Add Two Numbers",
    "difficulty": "Medium",
    "prompt": "You are given two non-empty linked lists representing two non-negative integers. The digits are stored in reverse order, and each node contains a single digit. Add the two numbers and return the sum as a linked list. Example: - Input: l1 = [2,4,3], l2 = [5,6,4] - Output: [7,0,8] - Explanation: 342 + 465 =.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "add-two-numbers"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "add-two-numbers"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "add-two-numbers-ii",
    "title": "Add Two Numbers II",
    "difficulty": "Medium",
    "prompt": "You are given two non-empty linked lists representing two non-negative integers. The most significant digit comes first and each of their nodes contains a single digit. Add the two numbers and return the sum as a linked list. You may assume the two numbers do not contain any leading zero, except the number 0.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "add-two-numbers-ii"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "add-two-numbers-ii"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "alien-dictionary",
    "title": "Alien Dictionary",
    "difficulty": "Hard",
    "prompt": "There is a new alien language that uses the English alphabet. However, the order of the letters is unknown to you. You are given a list of strings words from the alien language's dictionary. Now it is claimed that the strings in words are sorted lexicographically by the rules of this new language. If this claim is incorrect, and the given arrangement of.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "words",
          "type": "stringArray"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "words": [
            "wrt",
            "wrf",
            "er",
            "ett",
            "rftt"
          ]
        },
        "output": "wertf"
      }
    ],
    "tests": [
      {
        "input": {
          "words": [
            "wrt",
            "wrf",
            "er",
            "ett",
            "rftt"
          ]
        },
        "expected": "wertf"
      }
    ]
  },
  {
    "id": "all-paths-from-source-to-target",
    "title": "All Paths From Source to Target",
    "difficulty": "Medium",
    "prompt": "Given a directed acyclic graph (DAG) of n nodes labeled from 0 to n - 1, find all possible paths from node 0 to node n - 1 and return them in any order. The graph is given as follows: graph[i] is a list of all nodes you can visit from node.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "allocate-mailboxes",
    "title": "Allocate Mailboxes",
    "difficulty": "Hard",
    "prompt": "Place k mailboxes to minimize total distance from n.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "best-time-to-buy-and-sell-stock-ii",
    "title": "Best Time to Buy and Sell Stock II",
    "difficulty": "Medium",
    "prompt": "Unlimited transactions. Find maximum.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "prices",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "output": 7
      }
    ],
    "tests": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "expected": 7
      }
    ]
  },
  {
    "id": "best-time-to-buy-and-sell-stock-iii",
    "title": "Best Time to Buy and Sell Stock III",
    "difficulty": "Hard",
    "prompt": "Maximum profit with at most 2.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "prices",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "output": 7
      }
    ],
    "tests": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "expected": 7
      }
    ]
  },
  {
    "id": "best-time-to-buy-and-sell-stock-iv",
    "title": "Best Time to Buy and Sell Stock IV",
    "difficulty": "Hard",
    "prompt": "At most k transactions. Find maximum.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "prices",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "output": 7
      }
    ],
    "tests": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "expected": 7
      }
    ]
  },
  {
    "id": "best-time-to-buy-and-sell-stock-with-cooldown",
    "title": "Best Time to Buy and Sell Stock with Cooldown",
    "difficulty": "Medium",
    "prompt": "Unlimited transactions. Find maximum.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "prices",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "output": 7
      }
    ],
    "tests": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "expected": 7
      }
    ]
  },
  {
    "id": "best-time-to-buy-and-sell-stock-with-transaction-fee",
    "title": "Best Time to Buy and Sell Stock with Transaction Fee",
    "difficulty": "Medium",
    "prompt": "Unlimited transactions with a fee per.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "prices",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "output": 7
      }
    ],
    "tests": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "expected": 7
      }
    ]
  },
  {
    "id": "binary-subarrays-with-sum",
    "title": "Binary Subarrays With Sum",
    "difficulty": "Medium",
    "prompt": "Solve Binary Subarrays With Sum using the input model shown below. Return the requested value from solve(...).",
    "category": "ArraysAndHashing",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "goal",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            0,
            1,
            0,
            1
          ],
          "goal": 2
        },
        "output": 4
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            0,
            1,
            0,
            1
          ],
          "goal": 2
        },
        "expected": 4
      }
    ]
  },
  {
    "id": "binary-tree-inorder-traversal",
    "title": "Binary Tree Inorder Traversal",
    "difficulty": "Easy",
    "prompt": "Given the root of a binary tree, return the inorder traversal of its nodes'.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "binary-tree-level-order-traversal",
    "title": "Binary Tree Level Order Traversal",
    "difficulty": "Medium",
    "prompt": "Return the level-order traversal of a binary tree's.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "binary-tree-maximum-path-sum",
    "title": "Binary Tree Maximum Path Sum",
    "difficulty": "Hard",
    "prompt": "Find the maximum path sum between any two nodes in the tree. The path can be \"V-shaped\" - it doesn't have to be a straight line.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "can-make-palindrome-from-substring",
    "title": "Can Make Palindrome from Substring",
    "difficulty": "Medium",
    "prompt": "You are given a string s and array queries where queries[i] = [lefti, righti, ki]. We may rearrange the substring s[lefti...righti] for each query and then choose up to ki of them to replace with any lowercase English letter. If the substring is possible to be a palindrome string after the operations above, the result of the query is true. Otherwise, the.",
    "category": "Palindrome",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "cheapest-flights-within-k-stops",
    "title": "Cheapest Flights Within K Stops",
    "difficulty": "Medium",
    "prompt": "There are n cities connected by some number of flights. You are given an array flights where flights[i] = [fromi, toi, pricei] indicates that there is a flight from city fromi to city toi with cost pricei. You are also given three integers src, dst, and k, return the cheapest price from src to dst with at most k stops. If there is no such route, return.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "check-if-a-parentheses-string-can-be-valid",
    "title": "Check if a Parentheses String Can Be Valid",
    "difficulty": "Medium",
    "prompt": "Given parentheses string s and binary string locked. If locked[i]='0', can change s[i]. Return if s can be made.",
    "category": "Parenthesis",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "choose-k-elements-with-maximum-sum",
    "title": "Choose K Elements With Maximum Sum",
    "difficulty": "Medium",
    "prompt": "You are given two integer arrays, nums1 and nums2, both of length n, along with a positive integer k. For each index i from 0 to n - 1, perform the following: - Find all indices j where nums1[j] is less than nums1[i]. - Choose at most k values of nums2[j] at these indices to maximize the total sum. Return an array answer of size n, where answer[i].",
    "category": "Greedy",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "clone-graph",
    "title": "Clone Graph",
    "difficulty": "Medium",
    "prompt": "Given a reference of a node in a connected undirected graph. Return a deep copy (clone) of the graph. Each node in the graph contains a value (int) and a list (List[Node]) of its.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "combination-sum",
    "title": "Combination Sum",
    "difficulty": "Medium",
    "prompt": "Given an array of distinct integers candidates and a target integer target, return a list of all unique combinations of candidates where the chosen numbers sum to target. You may return the combinations in any order. The same number may be chosen from candidates an unlimited number of times. Two combinations are unique if the frequency of at least one of.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "combination-sum-ii",
    "title": "Combination Sum II",
    "difficulty": "Medium",
    "prompt": "Given a collection of candidate numbers (candidates) and a target number (target), find all unique combinations in candidates where the candidate numbers sum to target. Each number in candidates may only be used once in the combination. Note: The solution set must not contain duplicate.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "combination-sum-iii",
    "title": "Combination Sum III",
    "difficulty": "Medium",
    "prompt": "Find all valid combinations of k numbers that sum up to n such that the following conditions are true: - Only numbers 1 through 9 are used. - Each number is used at most once. Return a list of all possible valid combinations. The list must not contain the same combination twice, and the combinations may be returned in any.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "combinations",
    "title": "Combinations",
    "difficulty": "Medium",
    "prompt": "Given two integers n and k, return all possible combinations of k numbers chosen from the range [1, n]. We apply the template. The only difference is our termination condition is when our current array is length k as that finishes our combination. So this is basically getting all subsets of length k. (definition of a combination, as combination is basically.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2
          ]
        },
        "output": [
          [
            1,
            2
          ],
          [
            2,
            1
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2
          ]
        },
        "expected": [
          [
            1,
            2
          ],
          [
            2,
            1
          ]
        ]
      }
    ]
  },
  {
    "id": "construct-binary-tree-from-preorder-and-inorder-traversal",
    "title": "Construct Binary Tree from Preorder and Inorder Traversal",
    "difficulty": "Medium",
    "prompt": "Given preorder and inorder traversals of a tree, construct the binary.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "construct-binary-tree-from-preorder-and-postorder-traversal",
    "title": "Construct Binary Tree from Preorder and Postorder Traversal",
    "difficulty": "Medium",
    "prompt": "Given preorder and postorder traversals, construct the binary tree. If multiple valid trees exist, return.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "construct-quad-tree",
    "title": "Construct Quad Tree",
    "difficulty": "Medium",
    "prompt": "Given a n * n matrix grid of 0's and 1's only. We want to represent grid with a Quad-Tree. Return the root of the Quad-Tree representing.",
    "category": "DivideAndConquer",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "construct-string-with-minimum-cost",
    "title": "Construct String with Minimum Cost",
    "difficulty": "Hard",
    "prompt": "Form target using words where each word has a cost. Minimize total.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "target",
          "type": "string"
        },
        {
          "name": "words",
          "type": "stringArray"
        },
        {
          "name": "costs",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "target": "abcdef",
          "words": [
            "abdef",
            "abc",
            "d",
            "def",
            "ef"
          ],
          "costs": [
            100,
            1,
            1,
            10,
            5
          ]
        },
        "output": 7
      }
    ],
    "tests": [
      {
        "input": {
          "target": "abcdef",
          "words": [
            "abdef",
            "abc",
            "d",
            "def",
            "ef"
          ],
          "costs": [
            100,
            1,
            1,
            10,
            5
          ]
        },
        "expected": 7
      }
    ]
  },
  {
    "id": "contains-duplicate-ii",
    "title": "Contains Duplicate II",
    "difficulty": "Easy",
    "prompt": "Solve Contains Duplicate II using the input model shown below. Return the requested value from solve(...).",
    "category": "ArraysAndHashing",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "bool"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            1
          ]
        },
        "output": true
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            1
          ]
        },
        "expected": true
      }
    ]
  },
  {
    "id": "contains-duplicate-iii",
    "title": "Contains Duplicate III",
    "difficulty": "Hard",
    "prompt": "Check if there exist indices i, j where |i-j| <= k and |nums[i]-nums[j]| <=.",
    "category": "SortedList",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "bool"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            1
          ]
        },
        "output": true
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            1
          ]
        },
        "expected": true
      }
    ]
  },
  {
    "id": "continuous-subarray-sum",
    "title": "Continuous Subarray Sum",
    "difficulty": "Medium",
    "prompt": "Solve Continuous Subarray Sum using the input model shown below. Return the requested value from solve(...).",
    "category": "ArraysAndHashing",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "continuous-subarrays",
    "title": "Continuous Subarrays",
    "difficulty": "Medium",
    "prompt": "A subarray of nums is called continuous if for each pair of indices i1, i2 in the subarray,.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "copy-list-with-random-pointer",
    "title": "Copy List with Random Pointer",
    "difficulty": "Medium",
    "prompt": "A linked list of length n is given such that each node contains an additional random pointer, which could point to any node in the list, or null. Construct a deep copy of the list. Example:.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "count-days-without-meetings",
    "title": "Count Days Without Meetings",
    "difficulty": "Medium",
    "prompt": "You are given a positive integer days representing the total number of days an employee is available for work (starting from day 1). You are also given a 2D array meetings of size n where, meetings[i] = [start_i, end_i] represents the starting and ending days of meeting i (inclusive). Return the count of days when the employee is available for work but no.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "count-integers-in-intervals",
    "title": "Count Integers in Intervals",
    "difficulty": "Hard",
    "prompt": "Given an empty set of intervals, implement a data structure that can: - Add an interval to the set of intervals. - Count the number of integers that are present in at least one interval. Implement the CountIntervals class: - CountIntervals() Initializes the object with an empty set of intervals. - void add(int left, int right) Adds the interval [left,.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "count-number-of-nice-subarrays",
    "title": "Count Number of Nice Subarrays",
    "difficulty": "Medium",
    "prompt": "Solve Count Number Of Nice Subarrays using the input model shown below. Return the requested value from solve(...).",
    "category": "ArraysAndHashing",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "count-numbers-with-non-decreasing-digits",
    "title": "Count Numbers with Non-Decreasing Digits",
    "difficulty": "Hard",
    "prompt": "Count integers in [l, r] with non-decreasing.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "count-numbers-with-non-decreasing-digits"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "count-numbers-with-non-decreasing-digits"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "count-of-integers",
    "title": "Count of Integers",
    "difficulty": "Hard",
    "prompt": "Count integers in [num1, num2] where digit sum is in [min_sum,.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "count-of-integers"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "count-of-integers"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "count-of-interesting-subarrays",
    "title": "Count of Interesting Subarrays",
    "difficulty": "Medium",
    "prompt": "You are given a 0-indexed integer array.",
    "category": "ArraysAndHashing",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "count-of-smaller-numbers-after-self",
    "title": "Count of Smaller Numbers After Self",
    "difficulty": "Hard",
    "prompt": "For each element, count how many smaller elements are to its.",
    "category": "SegmentTree",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "count-of-smaller-numbers-after-self"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "count-of-smaller-numbers-after-self"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "count-stepping-numbers-in-range",
    "title": "Count Stepping Numbers in Range",
    "difficulty": "Hard",
    "prompt": "Count stepping numbers in [low, high] where adjacent digits differ by exactly.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "count-sub-islands",
    "title": "Count Sub Islands",
    "difficulty": "Medium",
    "prompt": "You are given two m x n binary matrices grid1 and grid2 containing only 0's (representing water) and 1's (representing land). An island is a group of 1's connected 4-directionally (horizontal or vertical). Any cells outside of the grid are considered water cells. An island in grid2 is considered a sub-island if there is an island in grid1 that contains all.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "course-schedule",
    "title": "Course Schedule",
    "difficulty": "Medium",
    "prompt": "There are a total of numCourses courses you have to take, labeled from 0 to numCourses - 1. You are given an array prerequisites where prerequisites[i] = [ai, bi] indicates that you must take course bi first if you want to take course ai. For example, the pair [0, 1], indicates that to take course 0 you have to first take course 1. Return true if you can.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "numCourses",
          "type": "int"
        },
        {
          "name": "prerequisites",
          "type": "intMatrix"
        }
      ],
      "returns": "bool"
    },
    "examples": [
      {
        "input": {
          "numCourses": 2,
          "prerequisites": [
            [
              1,
              0
            ]
          ]
        },
        "output": true
      }
    ],
    "tests": [
      {
        "input": {
          "numCourses": 2,
          "prerequisites": [
            [
              1,
              0
            ]
          ]
        },
        "expected": true
      }
    ]
  },
  {
    "id": "course-schedule-ii",
    "title": "Course Schedule II",
    "difficulty": "Medium",
    "prompt": "There are a total of numCourses courses you have to take, labeled from 0 to numCourses - 1. You are given an array prerequisites where prerequisites[i] = [ai, bi] indicates that you must take course bi first if you want to take course ai. For example, the pair [0, 1], indicates that to take course 0 you have to first take course 1. Return the ordering of.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "numCourses",
          "type": "int"
        },
        {
          "name": "prerequisites",
          "type": "intMatrix"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "numCourses": 2,
          "prerequisites": [
            [
              1,
              0
            ]
          ]
        },
        "output": [
          0,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "numCourses": 2,
          "prerequisites": [
            [
              1,
              0
            ]
          ]
        },
        "expected": [
          0,
          1
        ]
      }
    ]
  },
  {
    "id": "course-schedule-iv",
    "title": "Course Schedule IV",
    "difficulty": "Medium",
    "prompt": "There are a total of numCourses courses you have to take, labeled from 0 to numCourses - 1. You are given an array prerequisites where prerequisites[i] = [ai, bi] indicates that you must take course ai first if you want to take course bi. Prerequisites can also be indirect. If course a is a prerequisite of course b, and course b is a prerequisite of course.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "numCourses",
          "type": "int"
        },
        {
          "name": "prerequisites",
          "type": "intMatrix"
        }
      ],
      "returns": "bool"
    },
    "examples": [
      {
        "input": {
          "numCourses": 2,
          "prerequisites": [
            [
              1,
              0
            ]
          ]
        },
        "output": true
      }
    ],
    "tests": [
      {
        "input": {
          "numCourses": 2,
          "prerequisites": [
            [
              1,
              0
            ]
          ]
        },
        "expected": true
      }
    ]
  },
  {
    "id": "daily-temperatures",
    "title": "Daily Temperatures",
    "difficulty": "Medium",
    "prompt": "Solve Daily Temperatures using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "daily-temperatures"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "daily-temperatures"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "decode-string",
    "title": "Decode String",
    "difficulty": "Medium",
    "prompt": "Decode \"3[a2[c]]\" = \"accaccacc\". k[encoded] means repeat k.",
    "category": "Parenthesis",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "s": "3[a2[c]]"
        },
        "output": "accaccacc"
      }
    ],
    "tests": [
      {
        "input": {
          "s": "3[a2[c]]"
        },
        "expected": "accaccacc"
      }
    ]
  },
  {
    "id": "decode-ways",
    "title": "Decode Ways",
    "difficulty": "Medium",
    "prompt": "Count ways to decode a digit string where 'A'=1, 'B'=2, ...,.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "226"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "226"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "delete-node-in-a-linked-list",
    "title": "Delete Node in a Linked List",
    "difficulty": "Medium",
    "prompt": "Write a function to delete a node in a singly-linked list. You will not be given access to the head of the list, instead you will be given direct access to the node to be deleted. Example: - Input: head = [4,5,1,9], node = 5 - Output: [4,1,9] This problem has an interesting.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "design-add-and-search-words-data-structure",
    "title": "Design Add and Search Words Data Structure",
    "difficulty": "Medium",
    "prompt": "Design a data structure that supports adding new words and finding if a string matches any previously added string. Implement the WordDictionary class: - WordDictionary() Initializes the object. - void addWord(word) Adds word to the data structure, it can be matched later. - bool search(word) Returns true if there is any string in the data structure that.",
    "category": "Trie",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "different-ways-to-add-parentheses",
    "title": "Different Ways to Add Parentheses",
    "difficulty": "Medium",
    "prompt": "Return all possible results from computing expression with different.",
    "category": "Parenthesis",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "distribute-coins-in-binary-tree",
    "title": "Distribute Coins in Binary Tree",
    "difficulty": "Medium",
    "prompt": "Given a binary tree with n nodes where each node has some coins (total = n), return the minimum moves to make every node have exactly one coin. One move = transfer one coin between adjacent.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "divide-chocolate",
    "title": "Divide Chocolate",
    "difficulty": "Hard",
    "prompt": "Cut chocolate into k+1 pieces for you and k friends. You get the minimum piece. Maximize your.",
    "category": "BinarySearch",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "divide-intervals-into-minimum-number-of-groups",
    "title": "Divide Intervals Into Minimum Number of Groups",
    "difficulty": "Medium",
    "prompt": "You are given a 2D integer array intervals where intervals[i] = [lefti, righti] represents the inclusive interval [lefti, righti]. You have to divide the intervals into one or more groups such that each interval is in exactly one group, and no two intervals that are in the same group intersect each other. Return the minimum number of groups you need to.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "divide-players-into-teams-of-equal-skill",
    "title": "Divide Players Into Teams of Equal Skill",
    "difficulty": "Medium",
    "prompt": "You are given a positive integer array skill of even length n where skill[i] denotes the skill of the ith player. Divide the players into n / 2 teams of size 2 such that the total skill of each team is equal. Return the sum of the chemistry of all the teams, or return -1 if there is no way to divide the players. The chemistry of a team is equal to the.",
    "category": "TwoPointer",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "domino-and-tromino-tiling",
    "title": "Domino and Tromino Tiling",
    "difficulty": "Medium",
    "prompt": "Count ways to tile a 2×n board with dominoes (2×1) and trominoes.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "edit-distance",
    "title": "Edit Distance",
    "difficulty": "Medium",
    "prompt": "Find minimum operations (insert, delete, replace) to convert word1 to.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "edit-distance"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "edit-distance"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "evaluate-division",
    "title": "Evaluate Division",
    "difficulty": "Medium",
    "prompt": "You are given an array of variable pairs equations and an array of real numbers values, where equations[i] = [Ai, Bi] and values[i] represent the equation Ai / Bi = values[i]. Each Ai or Bi is a string that represents a single variable. You are also given some queries, where queries[j] = [Cj, Dj] represents the jth query where you must find the answer for.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "evaluate-division"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "evaluate-division"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "fill-a-special-grid",
    "title": "Fill a Special Grid",
    "difficulty": "Medium",
    "prompt": "You are given a non-negative integer n representing a 2^n x 2^n grid. You must fill the grid with integers from 0 to 2^(2n) - 1 to make it special. A grid is special if it satisfies all the following conditions: - All numbers in the top-right quadrant are smaller than those in the bottom-right quadrant. - All numbers in the bottom-right quadrant are smaller.",
    "category": "DivideAndConquer",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "fill-a-special-grid"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "fill-a-special-grid"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "find-all-anagrams-in-a-string",
    "title": "Find All Anagrams in a String",
    "difficulty": "Medium",
    "prompt": "Given two strings s and p, return an array of all the start indices of p's anagrams in s. You may return the answer in any.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        },
        {
          "name": "p",
          "type": "string"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "s": "cbaebabacd",
          "p": "abc"
        },
        "output": [
          0,
          6
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "s": "cbaebabacd",
          "p": "abc"
        },
        "expected": [
          0,
          6
        ]
      }
    ]
  },
  {
    "id": "find-eventual-safe-states",
    "title": "Find Eventual Safe States",
    "difficulty": "Medium",
    "prompt": "There is a directed graph of n nodes with each node labeled from 0 to n - 1. The graph is represented by a 0-indexed 2D integer array graph where graph[i] is an integer array of nodes adjacent to node i, meaning there is an edge from node i to each node in graph[i]. A node is a terminal node if there are no outgoing edges. A node is a safe node if every.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "find-first-and-last-position-of-element-in-sorted-array",
    "title": "Find First and Last Position of Element in Sorted Array",
    "difficulty": "Medium",
    "prompt": "Return first and last index of target in sorted array, or [-1, -1] if not.",
    "category": "BinarySearch",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "find-in-mountain-array",
    "title": "Find in Mountain Array",
    "difficulty": "Hard",
    "prompt": "Find target in a mountain array (increases then decreases). MountainArray interface has get(index) and.",
    "category": "BinarySearch",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "find-median-from-data-stream",
    "title": "Find Median from Data Stream",
    "difficulty": "Hard",
    "prompt": "The median is the middle value in an ordered integer list. If the size of the list is even, there is no middle value, and the median is the mean of the two middle values. Implement the MedianFinder class: • MedianFinder() initializes the MedianFinder object. • void addNum(int num) adds the integer num from the data stream. • double findMedian() returns the.",
    "category": "Heap",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "k",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "output": 5
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "expected": 5
      }
    ]
  },
  {
    "id": "find-the-k-beauty-of-a-number",
    "title": "Find the K-Beauty of a Number",
    "difficulty": "Easy",
    "prompt": "The k-beauty of an integer num is defined as the number of substrings of num when it is read as a string that meet the following conditions: • It has a length of k. • It is a divisor of.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "find-the-kth-largest-integer-in-the-array",
    "title": "Find the Kth Largest Integer in the Array",
    "difficulty": "Medium",
    "prompt": "You are given an array of strings nums and an integer k. Each string in nums represents an integer without leading zeros. Return the string that represents the kth largest integer in nums. Note: Duplicate numbers should be counted.",
    "category": "Heap",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "k",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "output": 5
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "expected": 5
      }
    ]
  },
  {
    "id": "find-the-original-array-of-prefix-xor",
    "title": "Find The Original Array of Prefix Xor",
    "difficulty": "Medium",
    "prompt": "Given prefix XOR array pref, find the original array arr where pref[i] = arr[0] ^ arr[1] ^ ... ^.",
    "category": "PrefixSum",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "find-the-shortest-superstring",
    "title": "Find the Shortest Superstring",
    "difficulty": "Hard",
    "prompt": "Find shortest string containing all given strings as.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "find-x-sum-of-all-k-long-subarrays-ii",
    "title": "Find X-Sum of All K-Long Subarrays II",
    "difficulty": "Hard",
    "prompt": "For each k-length window, find sum of x most frequent elements (by frequency, then by.",
    "category": "Heap",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "k",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "output": 5
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "expected": 5
      }
    ]
  },
  {
    "id": "finding-mk-average",
    "title": "Finding MK Average",
    "difficulty": "Hard",
    "prompt": "Design data structure that calculates MKAverage: average of last m elements excluding k smallest and k.",
    "category": "Heap",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "k",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "output": 5
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "expected": 5
      }
    ]
  },
  {
    "id": "frog-jump",
    "title": "Frog Jump",
    "difficulty": "Hard",
    "prompt": "Frog crosses river by jumping on stones. If last jump was k, next can be k-1, k, or.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "fruit-into-baskets",
    "title": "Fruit Into Baskets",
    "difficulty": "Medium",
    "prompt": "You are given 2 fruit baskets that can fit unlimited fruits of a single type. You want the maximum number of fruit you can pick, from a consecutive row of.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "fruit-into-baskets"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "fruit-into-baskets"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "furthest-building-you-can-reach",
    "title": "Furthest Building You Can Reach",
    "difficulty": "Medium",
    "prompt": "You are given an integer array heights representing the heights of buildings, some bricks, and some ladders. You start your journey from building 0 and move to the next building by possibly using bricks or ladders. While moving from building i to building i+1 (0-indexed): - If the current building's height is greater than or equal to the next building's.",
    "category": "Greedy",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "generate-parentheses",
    "title": "Generate Parentheses",
    "difficulty": "Medium",
    "prompt": "Generate all combinations of n pairs of well-formed.",
    "category": "Parenthesis",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "grid-teleportation-traversal",
    "title": "Grid Teleportation Traversal",
    "difficulty": "Medium",
    "prompt": "You are given a 2D character grid matrix of size m x n, where matrix[i][j] represents the cell at the intersection of the ith row and jth column. Each cell is one of the following: - '.' representing an empty cell. - '#' representing an obstacle. - An uppercase letter ('A'-'Z') representing a teleportation portal. You start at the top-left cell (0, 0), and.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "house-robber",
    "title": "House Robber",
    "difficulty": "Medium",
    "prompt": "Given an array of house values, rob houses to maximize profit. Cannot rob two adjacent.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "house-robber"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "house-robber"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "house-robber-ii",
    "title": "House Robber II",
    "difficulty": "Medium",
    "prompt": "Same as House Robber, but houses are arranged in a circle (first and last are.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "house-robber-ii"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "house-robber-ii"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "implement-trie-ii-prefix-tree",
    "title": "Implement Trie II (Prefix Tree)",
    "difficulty": "Medium",
    "prompt": "Implement the Trie class: - Trie() Initializes the trie object. - void insert(String word) Inserts the string word into the trie. - int countWordsEqualTo(String word) Returns the number of instances of the string word in the trie. - int countWordsStartingWith(String prefix) Returns the number of strings in the trie that have the string prefix as a prefix. -.",
    "category": "Trie",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "implement-trie-prefix-tree",
    "title": "Implement Trie (Prefix Tree)",
    "difficulty": "Medium",
    "prompt": "A trie (pronounced as \"try\") or prefix tree is a tree data structure used to efficiently store and retrieve keys in a dataset of strings. There are various applications of this data structure, such as autocomplete and spellchecker. Implement the Trie class: - Trie() Initializes the trie object. - void insert(String word) Inserts the string word into the.",
    "category": "Trie",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "insert-interval",
    "title": "Insert Interval",
    "difficulty": "Medium",
    "prompt": "You are given an array of non-overlapping intervals intervals where intervals[i] = [starti, endi] represent the start and the end of the ith interval and intervals is sorted in ascending order by starti. You are also given an interval newInterval = [start, end]. Insert newInterval into intervals such that intervals is still sorted in ascending order by.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "interval-list-intersections",
    "title": "Interval List Intersections",
    "difficulty": "Medium",
    "prompt": "You are given two lists of closed intervals, firstList and secondList, where firstList[i] = [starti, endi] and secondList[j] = [startj, endj]. Each list of intervals is pairwise disjoint and in sorted order. Return the intersection of these two interval.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "invert-binary-tree",
    "title": "Invert Binary Tree",
    "difficulty": "Easy",
    "prompt": "Given the root of a binary tree, invert the tree (swap every left node with its corresponding right.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "jump-game",
    "title": "Jump Game",
    "difficulty": "Medium",
    "prompt": "You are given an integer array nums. You are initially positioned at the array's first index, and each element in the array represents your maximum jump length at that position. Return true if you can reach the last index, or false.",
    "category": "Greedy",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "jump-game-ii",
    "title": "Jump Game II",
    "difficulty": "Medium",
    "prompt": "You are given a 0-indexed array of integers nums of length n. You are initially positioned at nums[0]. Each element nums[i] represents the maximum length of a forward jump from index i. In other words, if you are at nums[i], you can jump to any nums[i + j] where: - 0 <= j <= nums[i] and - i + j < n Return the minimum number of jumps to reach nums[n - 1]..",
    "category": "Greedy",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "k-empty-slots",
    "title": "K Empty Slots",
    "difficulty": "Hard",
    "prompt": "Find earliest day where two flowers bloom with exactly k empty slots between.",
    "category": "SortedList",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "k-radius-subarray-averages",
    "title": "K Radius Subarray Averages",
    "difficulty": "Medium",
    "prompt": "The k-radius average for a subarray centered at index i with radius k is the average of all elements between indices i-k and i+k (inclusive). Build and return an array where each element is the k-radius average, or -1 if there aren't enough.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "keys-and-rooms",
    "title": "Keys and Rooms",
    "difficulty": "Medium",
    "prompt": "There are n rooms labeled from 0 to n - 1 and all the rooms are locked except for room 0. Your goal is to visit all the rooms. However, you cannot enter a locked room without having its key. When you visit a room, you may find a set of distinct keys in it. Each key has a number on it, denoting which room it unlocks, and you can take all of them with you to.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "rooms",
          "type": "intMatrix"
        }
      ],
      "returns": "bool"
    },
    "examples": [
      {
        "input": {
          "rooms": [
            [
              1
            ],
            [
              2
            ],
            [
              3
            ],
            []
          ]
        },
        "output": true
      }
    ],
    "tests": [
      {
        "input": {
          "rooms": [
            [
              1
            ],
            [
              2
            ],
            [
              3
            ],
            []
          ]
        },
        "expected": true
      }
    ]
  },
  {
    "id": "knight-dialer",
    "title": "Knight Dialer",
    "difficulty": "Medium",
    "prompt": "Count distinct phone numbers of length n a chess knight can.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "knight-dialer"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "knight-dialer"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "kth-ancestor-of-a-tree-node",
    "title": "Kth Ancestor of a Tree Node",
    "difficulty": "Hard",
    "prompt": "Design data structure for efficient kth ancestor.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "parent",
          "type": "intArray"
        },
        {
          "name": "queries",
          "type": "intMatrix"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "parent": [
            -1,
            0,
            0,
            1,
            1,
            2,
            2
          ],
          "queries": [
            [
              3,
              1
            ],
            [
              5,
              2
            ],
            [
              6,
              3
            ]
          ]
        },
        "output": [
          1,
          0,
          -1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "parent": [
            -1,
            0,
            0,
            1,
            1,
            2,
            2
          ],
          "queries": [
            [
              3,
              1
            ],
            [
              5,
              2
            ],
            [
              6,
              3
            ]
          ]
        },
        "expected": [
          1,
          0,
          -1
        ]
      }
    ]
  },
  {
    "id": "largest-rectangle-in-histogram",
    "title": "Largest Rectangle in Histogram",
    "difficulty": "Hard",
    "prompt": "Solve Largest Rectangle In Histogram using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "k",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "output": 5
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "expected": 5
      }
    ]
  },
  {
    "id": "length-of-longest-fibonacci-subsequence",
    "title": "Length of Longest Fibonacci Subsequence",
    "difficulty": "Medium",
    "prompt": "Find longest subsequence where each element is sum of previous.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "length-of-the-longest-increasing-path",
    "title": "Length of the Longest Increasing Path",
    "difficulty": "Hard",
    "prompt": "Find longest path visiting coordinates in strictly increasing order by both x and.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "letter-combinations-of-a-phone-number",
    "title": "Letter Combinations of a Phone Number",
    "difficulty": "Medium",
    "prompt": "Given a string containing digits from 2-9 inclusive, return all possible letter combinations that the number could represent. Return the answer in any order. A mapping of digits to letters (just like on the telephone buttons) is given below. Note that 1 does not map to any letters. Example: - Input: digits = \"23\" - Output:.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2
          ]
        },
        "output": [
          [
            1,
            2
          ],
          [
            2,
            1
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2
          ]
        },
        "expected": [
          [
            1,
            2
          ],
          [
            2,
            1
          ]
        ]
      }
    ]
  },
  {
    "id": "longest-common-subsequence",
    "title": "Longest Common Subsequence",
    "difficulty": "Medium",
    "prompt": "Given two strings text1 and text2, return the length of their longest common.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "longest-continuous-subarray-with-absolute-diff-less-than-or-equal-to-limit",
    "title": "Longest Continuous Subarray With Absolute Diff <= Limit",
    "difficulty": "Medium",
    "prompt": "Find longest subarray where max - min <=.",
    "category": "SortedList",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "longest-increasing-subsequence",
    "title": "Longest Increasing Subsequence",
    "difficulty": "Medium",
    "prompt": "Given an integer array nums, return the length of the longest strictly increasing.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "longest-increasing-subsequence-ii",
    "title": "Longest Increasing Subsequence II",
    "difficulty": "Hard",
    "prompt": "Find LIS where consecutive elements differ by at most.",
    "category": "SegmentTree",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "longest-palindromic-subsequence",
    "title": "Longest Palindromic Subsequence",
    "difficulty": "Medium",
    "prompt": "Given a string s, find the longest palindromic subsequence's.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "bbbab"
        },
        "output": 4
      }
    ],
    "tests": [
      {
        "input": {
          "s": "bbbab"
        },
        "expected": 4
      }
    ]
  },
  {
    "id": "longest-palindromic-subsequence-ii",
    "title": "Longest Palindromic Subsequence II",
    "difficulty": "Medium",
    "prompt": "Find longest good palindromic subsequence: even length, no two consecutive characters equal except middle.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "bbbab"
        },
        "output": 4
      }
    ],
    "tests": [
      {
        "input": {
          "s": "bbbab"
        },
        "expected": 4
      }
    ]
  },
  {
    "id": "longest-substring-with-at-most-k-distinct-characters",
    "title": "Longest Substring with At Most K Distinct Characters",
    "difficulty": "Medium",
    "prompt": "Given a string s and an integer k, return the length of the longest substring of s that contains at most k distinct.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "lowest-common-ancestor-of-a-binary-search-tree",
    "title": "Lowest Common Ancestor of a Binary Search Tree",
    "difficulty": "Medium",
    "prompt": "Given a BST, find the lowest common ancestor (LCA) of two given.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "lowest-common-ancestor-of-a-binary-tree",
    "title": "Lowest Common Ancestor of a Binary Tree",
    "difficulty": "Medium",
    "prompt": "Given a binary tree, find the lowest common ancestor (LCA) of two given nodes p and.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "lowest-common-ancestor-of-a-binary-tree-ii",
    "title": "Lowest Common Ancestor of a Binary Tree II",
    "difficulty": "Medium",
    "prompt": "Find LCA of two nodes p and q. Return null if either node doesn't exist in the.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "lowest-common-ancestor-of-a-binary-tree-iii",
    "title": "Lowest Common Ancestor of a Binary Tree III",
    "difficulty": "Medium",
    "prompt": "Given two nodes p and q with parent pointers, return their.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "make-sum-divisible-by-p",
    "title": "Make Sum Divisible by P",
    "difficulty": "Medium",
    "prompt": "Solve Make Sum Divisible By P using the input model shown below. Return the requested value from solve(...).",
    "category": "ArraysAndHashing",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "making-a-large-island",
    "title": "Making A Large Island",
    "difficulty": "Hard",
    "prompt": "You are given an n x n binary matrix grid. You are allowed to change at most one 0 to be 1. Return the size of the largest island in grid after applying this operation. An island is a 4-directionally connected group of.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "max-area-of-island",
    "title": "Max Area of Island",
    "difficulty": "Medium",
    "prompt": "You are given an m x n binary matrix grid. An island is a group of 1's (representing land) connected 4-directionally (horizontal or vertical.) You may assume all four edges of the grid are surrounded by water. The area of an island is the number of cells with a value 1 in the island. Return the maximum area of an island in grid. If there is no island,.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "max-consecutive-ones-iii",
    "title": "Max Consecutive Ones III",
    "difficulty": "Medium",
    "prompt": "Given a binary array nums and an integer k, return the maximum number of consecutive 1's in the array if you can flip at most k.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "max-consecutive-ones-iii"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "max-consecutive-ones-iii"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "maximal-rectangle",
    "title": "Maximal Rectangle",
    "difficulty": "Hard",
    "prompt": "Solve Maximal Rectangle using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "maximal-rectangle"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "maximal-rectangle"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "maximal-square",
    "title": "Maximal Square",
    "difficulty": "Medium",
    "prompt": "Given an m×n binary matrix, find the largest square containing only 1's and return its.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "maximal-square"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "maximal-square"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "maximize-greatness-of-an-array",
    "title": "Maximize Greatness of an Array",
    "difficulty": "Medium",
    "prompt": "You are given a 0-indexed integer array nums. You are allowed to permute nums into a new array perm of your choosing. We define the greatness of nums be the number of indices 0 <= i < nums.length for which perm[i] > nums[i]. Return the maximum possible greatness you can achieve after permuting.",
    "category": "TwoPointer",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "maximize-profit-from-task-assignment",
    "title": "Maximize Profit from Task Assignment",
    "difficulty": "Medium",
    "prompt": "You are given an integer array workers, where workers[i] represents the skill level of the ith worker. You are also given a 2D integer array tasks, where: - tasks[i][0] represents the skill requirement needed to complete the task. - tasks[i][1] represents the profit earned from completing the task. Each worker can complete at most one task, and they can.",
    "category": "Greedy",
    "signature": {
      "args": [
        {
          "name": "prices",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "output": 7
      }
    ],
    "tests": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "expected": 7
      }
    ]
  },
  {
    "id": "maximize-score-after-n-operations",
    "title": "Maximize Score After N Operations",
    "difficulty": "Hard",
    "prompt": "Perform n operations, each picking 2 elements with score = op_num × gcd(x,.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "maximize-score-after-n-operations"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "maximize-score-after-n-operations"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "maximize-the-number-of-target-nodes-after-connecting-trees-i",
    "title": "Maximize the Number of Target Nodes After Connecting Trees I",
    "difficulty": "Hard",
    "prompt": "Connect node i in tree1 to best node in tree2 to maximize nodes within k edges of.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "maximize-win-from-two-segments",
    "title": "Maximize Win From Two Segments",
    "difficulty": "Medium",
    "prompt": "Choose two non-overlapping segments of length k to maximize covered.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "maximize-win-from-two-segments"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "maximize-win-from-two-segments"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "maximum-average-subarray-ii",
    "title": "Maximum Average Subarray II",
    "difficulty": "Hard",
    "prompt": "Find contiguous subarray of length >= k with maximum.",
    "category": "BinarySearch",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "maximum-candies-allocated-to-k-children",
    "title": "Maximum Candies Allocated to K Children",
    "difficulty": "Medium",
    "prompt": "Find maximum candies per child when dividing piles among k.",
    "category": "BinarySearch",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "maximum-depth-of-binary-tree",
    "title": "Maximum Depth of Binary Tree",
    "difficulty": "Easy",
    "prompt": "Find the height of a binary tree (the number of nodes along the longest path from root to.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "maximum-earnings-from-taxi",
    "title": "Maximum Earnings From Taxi",
    "difficulty": "Medium",
    "prompt": "Pick up passengers with [start, end, tip]. Earn end-start+tip per ride. Maximize.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "maximum-earnings-from-taxi"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "maximum-earnings-from-taxi"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "maximum-number-of-events-that-can-be-attended-ii",
    "title": "Maximum Number of Events That Can Be Attended II",
    "difficulty": "Hard",
    "prompt": "Attend at most k events (non-overlapping) to maximize total.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "maximum-number-of-fish-in-a-grid",
    "title": "Maximum Number of Fish in a Grid",
    "difficulty": "Medium",
    "prompt": "You are given a 0-indexed 2D matrix grid of size m x n, where (r, c) represents: - A land cell if grid[r][c] = 0, or - A water cell containing grid[r][c] fish, if grid[r][c] > 0. A fisher can start at any water cell (r, c) and can do the following operations any number of times: - Catch all the fish at cell (r, c), or - Move to any adjacent water cell..",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "maximum-profit-in-job-scheduling",
    "title": "Maximum Profit in Job Scheduling",
    "difficulty": "Hard",
    "prompt": "Given jobs with start time, end time, and profit, find maximum profit with non-overlapping.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "prices",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "output": 7
      }
    ],
    "tests": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "expected": 7
      }
    ]
  },
  {
    "id": "maximum-students-taking-exam",
    "title": "Maximum Students Taking Exam",
    "difficulty": "Hard",
    "prompt": "Place students in seats (avoiding cheating) to maximize count. Can't see diagonally.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "maximum-students-taking-exam"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "maximum-students-taking-exam"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "maximum-sum-with-at-most-k-elements",
    "title": "Maximum Sum With at Most K Elements",
    "difficulty": "Medium",
    "prompt": "You are given a 2D integer matrix grid of size n x m, an integer array limits of length n, and an integer k. The task is to find the maximum sum of at most k elements from the matrix grid such that: • The number of elements taken from the ith row of grid does not exceed limits[i]. Return the maximum.",
    "category": "Heap",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "maximum-weighted-k-edge-path",
    "title": "Maximum Weighted K-Edge Path",
    "difficulty": "Medium",
    "prompt": "Find max sum path with exactly k edges in DAG, sum must be <.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "maximum-xor-of-two-numbers-in-an-array",
    "title": "Maximum XOR of Two Numbers in an Array",
    "difficulty": "Medium",
    "prompt": "Given an integer array nums, return the maximum result of nums[i] XOR nums[j], where 0 ≤ i, j < n. Example: Input: nums = [3,10,5,25,2,8] Output: 28 Explanation: The maximum XOR is achieved by 5 XOR 25 =.",
    "category": "Trie",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "maximum-xor-with-an-element-from-array",
    "title": "Maximum XOR With an Element From Array",
    "difficulty": "Hard",
    "prompt": "Given an array nums and queries of the form [xi, mi], find the maximum XOR value of xi with any number in nums that is less than or equal to mi. Return -1 if no number in nums is less than or equal to.",
    "category": "Trie",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "meeting-rooms",
    "title": "Meeting Rooms",
    "difficulty": "Easy",
    "prompt": "Given an array of meeting time intervals where intervals[i] = [starti, endi], determine if a person could attend all meetings. Example 1: - Input: intervals = [[0,30],[5,10],[15,20]] - Output: false Example 2: - Input: intervals = [[7,10],[2,4]] - Output:.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "meeting-rooms-ii",
    "title": "Meeting Rooms II",
    "difficulty": "Medium",
    "prompt": "Given an array of meeting time intervals intervals where intervals[i] = [starti, endi], return the minimum number of conference rooms required. Example 1: - Input: intervals = [[0,30],[5,10],[15,20]] - Output:.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "merge-intervals",
    "title": "Merge Intervals",
    "difficulty": "Medium",
    "prompt": "Given an array of intervals where intervals[i] = [starti, endi], merge all overlapping intervals, and return an array of the non-overlapping intervals that cover all the intervals in the input. Example: - Input: intervals = [[1,3],[2,6],[8,10],[15,18]] - Output: [[1,6],[8,10],[15,18]] - Explanation: Since intervals [1,3] and [2,6] overlap, merge them into.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "merge-k-sorted-lists",
    "title": "Merge k Sorted Lists",
    "difficulty": "Hard",
    "prompt": "You are given an array of k linked-lists, each linked-list is sorted in ascending order. Merge all the linked-lists into one sorted linked-list and return it. Example: - Input: lists = [[1→4→5], [1→3→4], [2→6]] - Output: [1→1→2→3→4→4→5→6] This problem can be thought of as an extension of our earlier \"Merge Two Sorted Lists\" problem. We have several.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "merge-two-sorted-lists",
    "title": "Merge Two Sorted Lists",
    "difficulty": "Easy",
    "prompt": "Merge two sorted linked lists and return it as a sorted list. Example: - List1: 1→2→4→null - List2: 1→3→4→null - Output: 1→1→2→3→4→4→null This is a great place to apply our dummy node.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "middle-of-the-linked-list",
    "title": "Middle of the Linked List",
    "difficulty": "Easy",
    "prompt": "Given a non-empty, singly linked list, return a middle node of the linked list. If there are two middle nodes, return the second middle node. Example: - Input: [1,2,3,4,5] - Output: [3,4,5] (The middle node is 3) This is a classic application of the fast and slow pointer.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "minimum-absolute-difference-in-sliding-submatrix",
    "title": "Minimum Absolute Difference in Sliding Submatrix",
    "difficulty": "Medium",
    "prompt": "For every k×k submatrix, find minimum absolute difference between any two distinct.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "minimum-absolute-difference-in-sliding-submatrix"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "minimum-absolute-difference-in-sliding-submatrix"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "minimum-consecutive-cards-to-pick-up",
    "title": "Minimum Consecutive Cards to Pick Up",
    "difficulty": "Medium",
    "prompt": "Given an integer array cards where cards[i] represents the value of the ith card. A pair of cards are matching if they have the same value. Return the minimum number of consecutive cards you have to pick up to have a pair of matching cards. If impossible, return.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "minimum-consecutive-cards-to-pick-up"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "minimum-consecutive-cards-to-pick-up"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "minimum-cost-for-tickets",
    "title": "Minimum Cost For Tickets",
    "difficulty": "Medium",
    "prompt": "Given travel days and ticket costs for 1-day, 7-day, and 30-day passes, find minimum cost to cover all travel.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "minimum-cost-to-make-at-least-one-valid-path-in-a-grid",
    "title": "Minimum Cost to Make at Least One Valid Path in a Grid",
    "difficulty": "Hard",
    "prompt": "Given an m x n grid. Each cell of the grid has a sign pointing to the next cell you should visit if you are currently in this cell. The sign of grid[i][j] can be: - 1 which means go to the cell to the right. (i.e go from grid[i][j] to grid[i][j + 1]) - 2 which means go to the cell to the left. (i.e go from grid[i][j] to grid[i][j - 1]) - 3 which means go to.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-cost-to-reach-destination-in-time",
    "title": "Minimum Cost to Reach Destination in Time",
    "difficulty": "Hard",
    "prompt": "Find minimum cost path from 0 to n-1 within maxTime. Each city has passing.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "minimum-cost-to-reach-destination-in-time"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "minimum-cost-to-reach-destination-in-time"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "minimum-depth-of-binary-tree",
    "title": "Minimum Depth of Binary Tree",
    "difficulty": "Easy",
    "prompt": "Find the minimum depth of a binary tree (shortest path from root to.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "minimum-falling-path-sum",
    "title": "Minimum Falling Path Sum",
    "difficulty": "Medium",
    "prompt": "Find minimum sum path from top row to bottom, moving.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-falling-path-sum-ii",
    "title": "Minimum Falling Path Sum II",
    "difficulty": "Hard",
    "prompt": "Same as falling path but next row column must be.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-genetic-mutation",
    "title": "Minimum Genetic Mutation",
    "difficulty": "Medium",
    "prompt": "A gene string can be represented by an 8-character long string, with choices from 'A', 'C', 'G', and 'T'. Suppose we need to investigate a mutation from a gene string startGene to a gene string endGene where one mutation is defined as one single character changed in the gene string. There is also a gene bank bank that records all the valid gene mutations. A.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-moves-to-clean-the-classroom",
    "title": "Minimum Moves to Clean the Classroom",
    "difficulty": "Hard",
    "prompt": "Given a classroom grid with litter (L), energy restore points (R), obstacles (X), and a start position (S), find the minimum moves to collect all.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-number-of-swaps-to-make-the-string-balanced",
    "title": "Minimum Swaps to Make String Balanced",
    "difficulty": "Medium",
    "prompt": "Given string with equal '[' and ']', find minimum swaps to.",
    "category": "Parenthesis",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-number-of-valid-strings-to-form-target-i",
    "title": "Minimum Number of Valid Strings to Form Target I",
    "difficulty": "Medium",
    "prompt": "Form target using minimum number of prefixes from given words.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-path-cost-in-a-grid",
    "title": "Minimum Path Cost in a Grid",
    "difficulty": "Medium",
    "prompt": "Find minimum cost path from any cell in first row to any cell in last row. moveCost[v][j] is cost to move from value v to column.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-path-sum",
    "title": "Minimum Path Sum",
    "difficulty": "Medium",
    "prompt": "Given an m×n grid filled with non-negative numbers, find a path from top-left to bottom-right minimizing the sum. Can only move right or.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-remove-to-make-valid-parentheses",
    "title": "Minimum Remove to Make Valid Parentheses",
    "difficulty": "Medium",
    "prompt": "Remove minimum parentheses to make string valid. Return any valid.",
    "category": "Parenthesis",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-sideway-jumps",
    "title": "Minimum Sideway Jumps",
    "difficulty": "Medium",
    "prompt": "3-lane road with obstacles. Minimize sideway jumps to reach.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "minimum-swaps-to-sort-by-digit-sum",
    "title": "Minimum Swaps to Sort by Digit Sum",
    "difficulty": "Medium",
    "prompt": "Solve Minimum Swaps To Sort By Digit Sum using the input model shown below. Return the requested value from solve(...).",
    "category": "ArraysAndHashing",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "minimum-time-to-complete-trips",
    "title": "Minimum Time to Complete Trips",
    "difficulty": "Medium",
    "prompt": "Find minimum time for buses to complete totalTrips. time[i] = trip duration for bus.",
    "category": "BinarySearch",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "minimum-time-to-kill-all-monsters",
    "title": "Minimum Time to Kill All Monsters",
    "difficulty": "Hard",
    "prompt": "Kill monsters with increasing mana gain. Find minimum days to kill.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "minimum-time-to-kill-all-monsters"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "minimum-time-to-kill-all-monsters"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "minimum-time-to-visit-all-houses",
    "title": "Minimum Time to Visit All Houses",
    "difficulty": "Medium",
    "prompt": "Houses arranged in circle with forward/backward roads. Find minimum time to visit houses in order given by.",
    "category": "PrefixSum",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "minimum-time-to-visit-all-houses"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "minimum-time-to-visit-all-houses"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "minimum-weighted-subgraph-with-the-required-paths-ii",
    "title": "Minimum Weighted Subgraph With the Required Paths II",
    "difficulty": "Hard",
    "prompt": "Find min weight subtree connecting src1, src2, and dest for each.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "minimum-window-substring",
    "title": "Minimum Window Substring",
    "difficulty": "Hard",
    "prompt": "Given two strings s and t, return the minimum window substring of s such that every character in t (including duplicates) is included in the window. If there is no such substring, return.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        },
        {
          "name": "t",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "s": "ADOBECODEBANC",
          "t": "ABC"
        },
        "output": "BANC"
      }
    ],
    "tests": [
      {
        "input": {
          "s": "ADOBECODEBANC",
          "t": "ABC"
        },
        "expected": "BANC"
      }
    ]
  },
  {
    "id": "my-calendar-i",
    "title": "My Calendar I",
    "difficulty": "Medium",
    "prompt": "You are implementing a program to use as your calendar. We can add a new event if adding the event will not cause a double booking. A double booking happens when two events have some non-empty intersection. Implement the MyCalendar class: - MyCalendar() Initializes the calendar object. - boolean book(int startTime, int endTime) Returns true if the event can.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "bookings",
          "type": "intMatrix"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "bookings": [
            [
              10,
              20
            ],
            [
              15,
              25
            ],
            [
              20,
              30
            ]
          ]
        },
        "output": [
          1,
          0,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "bookings": [
            [
              10,
              20
            ],
            [
              15,
              25
            ],
            [
              20,
              30
            ]
          ]
        },
        "expected": [
          1,
          0,
          1
        ]
      }
    ]
  },
  {
    "id": "my-calendar-ii",
    "title": "My Calendar II",
    "difficulty": "Medium",
    "prompt": "Implement a MyCalendarTwo class where double booking is allowed, but triple booking is.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "bookings",
          "type": "intMatrix"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "bookings": [
            [
              10,
              20
            ],
            [
              15,
              25
            ],
            [
              20,
              30
            ]
          ]
        },
        "output": [
          1,
          0,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "bookings": [
            [
              10,
              20
            ],
            [
              15,
              25
            ],
            [
              20,
              30
            ]
          ]
        },
        "expected": [
          1,
          0,
          1
        ]
      }
    ]
  },
  {
    "id": "my-calendar-iii",
    "title": "My Calendar III",
    "difficulty": "Hard",
    "prompt": "Implement a MyCalendarThree class that accepts all bookings and returns the maximum k-booking (the maximum number of overlapping.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "bookings",
          "type": "intMatrix"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "bookings": [
            [
              10,
              20
            ],
            [
              15,
              25
            ],
            [
              20,
              30
            ]
          ]
        },
        "output": [
          1,
          2,
          2
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "bookings": [
            [
              10,
              20
            ],
            [
              15,
              25
            ],
            [
              20,
              30
            ]
          ]
        },
        "expected": [
          1,
          2,
          2
        ]
      }
    ]
  },
  {
    "id": "network-delay-time",
    "title": "Network Delay Time",
    "difficulty": "Medium",
    "prompt": "You are given a network of n nodes, labeled from 1 to n. You are also given times, a list of travel times as directed edges times[i] = (ui, vi, wi), where ui is the source node, vi is the target node, and wi is the time it takes for a signal to travel from source to target. We will send a signal from a given node k. Return the minimum time it takes for all.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "next-greater-element-i",
    "title": "Next Greater Element I",
    "difficulty": "Easy",
    "prompt": "Solve Next Greater Element I using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "next-greater-element-i"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "next-greater-element-i"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "next-greater-element-ii",
    "title": "Next Greater Element II",
    "difficulty": "Medium",
    "prompt": "Solve Next Greater Element II using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "next-greater-element-ii"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "next-greater-element-ii"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "number-of-beautiful-integers-in-the-range",
    "title": "Number of Beautiful Integers in the Range",
    "difficulty": "Hard",
    "prompt": "Count integers in [low, high] with equal odd/even digits and divisible by.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "number-of-connected-components-in-an-undirected-graph",
    "title": "Number of Connected Components in an Undirected Graph",
    "difficulty": "Medium",
    "prompt": "You have a graph of n nodes. You are given an integer n and an array edges where edges[i] = [ai, bi] indicates that there is an edge between ai and bi in the graph. Return the number of connected components in the.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "number-of-distinct-islands",
    "title": "Number of Distinct Islands",
    "difficulty": "Medium",
    "prompt": "You are given an m x n binary matrix grid. An island is a group of 1's (representing land) connected 4-directionally (horizontal or vertical.) You may assume all four edges of the grid are surrounded by water. An island is considered to be the same as another if and only if one island can be translated (and not rotated or reflected) to equal the other..",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "number-of-flowers-in-full-bloom",
    "title": "Number of Flowers in Full Bloom",
    "difficulty": "Hard",
    "prompt": "You are given a 0-indexed 2D integer array flowers, where flowers[i] = [starti, endi] means the ith flower will be in full bloom from starti to endi (inclusive). You are also given a 0-indexed integer array people of size n, where people[i] is the time that the ith person will arrive to see the flowers. Return an integer array answer of size n, where.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "number-of-islands",
    "title": "Number of Islands",
    "difficulty": "Medium",
    "prompt": "Given an m x n 2D binary grid grid which represents a map of '1's (land) and '0's (water), return the number of islands. An island is surrounded by water and is formed by connecting adjacent lands horizontally or vertically. You may assume all four edges of the grid are all surrounded by.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "number-of-provinces",
    "title": "Number of Provinces",
    "difficulty": "Medium",
    "prompt": "There are n cities. Some of them are connected, while some are not. If city a is connected directly with city b, and city b is connected directly with city c, then city a is connected indirectly with city c. A province is a group of directly or indirectly connected cities and no other cities outside of the group. You are given an n x n matrix isConnected.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "number-of-sub-arrays-with-odd-sum",
    "title": "Number of Sub-arrays With Odd Sum",
    "difficulty": "Medium",
    "prompt": "Solve Number Of Sub Arrays With Odd Sum using the input model shown below. Return the requested value from solve(...).",
    "category": "ArraysAndHashing",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "goal",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            0,
            1,
            0,
            1
          ],
          "goal": 2
        },
        "output": 4
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            0,
            1,
            0,
            1
          ],
          "goal": 2
        },
        "expected": 4
      }
    ]
  },
  {
    "id": "number-of-substrings-containing-all-three-characters",
    "title": "Number of Substrings Containing All Three Characters",
    "difficulty": "Medium",
    "prompt": "Given a string s consisting only of characters a, b and c. Return the number of substrings containing at least one occurrence of all these characters a, b and.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "number-of-visible-people-in-a-queue",
    "title": "Number of Visible People in a Queue",
    "difficulty": "Hard",
    "prompt": "Solve Number Of Visible People In A Queue using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "number-of-visible-people-in-a-queue"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "number-of-visible-people-in-a-queue"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "number-of-ways-to-build-sturdy-brick-wall",
    "title": "Number of Ways to Build Sturdy Brick Wall",
    "difficulty": "Hard",
    "prompt": "Build wall of given height and width using bricks. Adjacent rows must not have brick edges at same.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "number-of-ways-to-build-sturdy-brick-wall"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "number-of-ways-to-build-sturdy-brick-wall"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "number-of-ways-to-wear-different-hats-to-each-other",
    "title": "Number of Ways to Wear Different Hats to Each Other",
    "difficulty": "Hard",
    "prompt": "n people, 40 hats. Each person has preference list. Count valid.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "number-of-ways-to-wear-different-hats-to-each-other"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "number-of-ways-to-wear-different-hats-to-each-other"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "online-stock-span",
    "title": "Online Stock Span",
    "difficulty": "Medium",
    "prompt": "Solve Online Stock Span using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "prices",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "output": 7
      }
    ],
    "tests": [
      {
        "input": {
          "prices": [
            7,
            1,
            5,
            3,
            6,
            4
          ]
        },
        "expected": 7
      }
    ]
  },
  {
    "id": "pacific-atlantic-water-flow",
    "title": "Pacific Atlantic Water Flow",
    "difficulty": "Medium",
    "prompt": "There is an m x n rectangular island that borders both the Pacific Ocean and Atlantic Ocean. The Pacific Ocean touches the island's left and top edges, and the Atlantic Ocean touches the island's right and bottom edges. The island is partitioned into a grid of square cells. You are given an m x n integer matrix heights where heights[r][c] represents the.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "pacific-atlantic-water-flow"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "pacific-atlantic-water-flow"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "paint-fence",
    "title": "Paint Fence",
    "difficulty": "Medium",
    "prompt": "Paint n posts with k colors. No three consecutive posts same color. Count.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "paint-house",
    "title": "Paint House",
    "difficulty": "Medium",
    "prompt": "Paint n houses with 3 colors. No two adjacent houses same color. Minimize.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "paint-house-ii",
    "title": "Paint House II",
    "difficulty": "Hard",
    "prompt": "Paint n houses with k colors. No two adjacent same color. Minimize.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "palindrome-partitioning",
    "title": "Palindrome Partitioning",
    "difficulty": "Medium",
    "prompt": "Given a string s, partition s such that every substring of the partition is a palindrome. Return all possible palindrome partitioning of s. Example: - Input: s = \"aab\" - Output:.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "palindromic-substrings",
    "title": "Palindromic Substrings",
    "difficulty": "Medium",
    "prompt": "Given a string s, return the number of palindromic substrings in.",
    "category": "Palindrome",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "aaa"
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "s": "aaa"
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "partition-equal-subset-sum",
    "title": "Partition Equal Subset Sum",
    "difficulty": "Medium",
    "prompt": "Given an integer array nums, return true if you can partition it into two subsets with equal.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "partition-list",
    "title": "Partition List",
    "difficulty": "Medium",
    "prompt": "Given the head of a linked list and a value x, partition it such that all nodes less than x come before nodes greater than or equal to x. You should preserve the original relative order of the nodes in each of the two partitions. Example: - Input: 1→4→3→2→5→2→null, x = 3 - Output: 1→2→2→4→3→5→null For this problem, we can maintain two separate lists (one.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "partition-to-k-equal-sum-subsets",
    "title": "Partition to K Equal Sum Subsets",
    "difficulty": "Medium",
    "prompt": "Partition array into k subsets with equal.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "path-sum",
    "title": "Path Sum",
    "difficulty": "Easy",
    "prompt": "Given the root of a binary tree and a target sum, determine if there exists a root-to-leaf path where the sum of all node values equals the.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "path-with-maximum-minimum-value",
    "title": "Path With Maximum Minimum Value",
    "difficulty": "Medium",
    "prompt": "Given an m x n integer matrix grid, return the maximum score of a path starting at (0, 0) and ending at (m - 1, n - 1) moving in the 4 cardinal directions. The score of a path is the minimum value in that path. For example, the score of the path 8 → 4 → 5 → 9 is.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "path-with-maximum-probability",
    "title": "Path with Maximum Probability",
    "difficulty": "Medium",
    "prompt": "You are given an undirected weighted graph of n nodes (0-indexed), represented by an edge list where edges[i] = [a, b] is an undirected edge connecting the nodes a and b with a probability of success of traversing that edge succProb[i]. Given two nodes start and end, find the path with the maximum probability of success to go from start to end and return.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "path-with-minimum-effort",
    "title": "Path With Minimum Effort",
    "difficulty": "Medium",
    "prompt": "You are a hiker preparing for an upcoming hike. You are given heights, a 2D array of size rows x columns, where heights[row][col] represents the height of cell (row, col). You are situated in the top-left cell, (0, 0), and you hope to travel to the bottom-right cell, (rows-1, columns-1) (i.e., 0-indexed). You can move up, down, left, or right, and you wish.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "permutation-in-string",
    "title": "Permutation in String",
    "difficulty": "Medium",
    "prompt": "Given two strings s1 and s2, return true if s2 contains a permutation of s1, or false otherwise. In other words, return true if one of s1's permutations is the substring of.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "permutations",
    "title": "Permutations",
    "difficulty": "Medium",
    "prompt": "Given an array nums of distinct integers, return all the possible permutations. You can return the answer in any order. We apply the same template. The only difference is instead of maintaining a new array 'curr', we can use the same original array nums, and just swap the values at index i and index j instead of adding.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "permutations-ii",
    "title": "Permutations II",
    "difficulty": "Medium",
    "prompt": "Given a collection of numbers, nums, that might contain duplicates, return all possible unique permutations in any.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "range-sum-query-2d-immutable",
    "title": "Range Sum Query 2D - Immutable",
    "difficulty": "Medium",
    "prompt": "Given a 2D matrix, handle multiple queries to calculate sum of elements inside a rectangle defined by (row1, col1) to (row2,.",
    "category": "PrefixSum",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "range-sum-query-mutable",
    "title": "Range Sum Query - Mutable",
    "difficulty": "Medium",
    "prompt": "Handle array updates and range sum.",
    "category": "SegmentTree",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "regular-expression-matching",
    "title": "Regular Expression Matching",
    "difficulty": "Hard",
    "prompt": "Implement regex matching with '.' (any char) and '*' (zero or more of.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "regular-expression-matching"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "regular-expression-matching"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "remove-covered-intervals",
    "title": "Remove Covered Intervals",
    "difficulty": "Medium",
    "prompt": "Given an array intervals where intervals[i] = [li, ri] represent the interval [li, ri), remove all intervals that are covered by another interval in the list. The interval [a, b) is covered by the interval [c, d) if and only if c <= a and b <= d. Return the number of remaining.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "remove-interval",
    "title": "Remove Interval",
    "difficulty": "Medium",
    "prompt": "You are given a sorted list of disjoint intervals intervals representing a set of real numbers, where intervals[i] = [ai, bi] represents the interval [ai, bi). You are also given another interval toBeRemoved. Return the set of real numbers with the interval toBeRemoved removed from.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "remove-invalid-parentheses",
    "title": "Remove Invalid Parentheses",
    "difficulty": "Hard",
    "prompt": "Given a string s that contains parentheses and letters, remove the minimum number of invalid parentheses to make the input string valid. Return a list of unique strings that are valid with the minimum number of removals. You may return the answer in any.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "remove-nth-node-from-end-of-list",
    "title": "Remove Nth Node From End of List",
    "difficulty": "Medium",
    "prompt": "Given the head of a linked list, remove the nth node from the end of the list and return its head. Example: - Input: 1→2→3→4→5→null, n = 2 - Output: 1→2→3→5→null This problem introduces the two-pointer.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "reverse-linked-list",
    "title": "Reverse Linked List",
    "difficulty": "Easy",
    "prompt": "Given the head of a singly linked list, reverse the list, and return the new head. Example: - Input: 1→2→3→4→5→null - Output: 5→4→3→2→1→null This is the quintessential linked list problem. We need to reverse the direction of all pointers in the.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "reverse-linked-list-ii",
    "title": "Reverse Linked List II",
    "difficulty": "Medium",
    "prompt": "Given the head of a linked list and two positions left and right, reverse the nodes of the list from position left to position right, and return the reversed list. Example: - Input: 1→2→3→4→5→null, left = 2, right = 4 - Output: 1→4→3→2→5→null This problem requires careful pointer manipulation to reverse only a portion of the.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "rotate-list",
    "title": "Rotate List",
    "difficulty": "Medium",
    "prompt": "Given the head of a linked list, rotate the list to the right by k places. Example: - Input: 1→2→3→4→5→null, k = 2 - Output: 4→5→1→2→3→null This problem requires several key steps: finding the length of the list, connecting the tail to the head to form a cycle, then breaking the cycle at the right.",
    "category": "LinkedList",
    "signature": {
      "args": [
        {
          "name": "head",
          "type": "intArray"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "output": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "head": [
            1,
            2,
            3,
            4,
            5
          ]
        },
        "expected": [
          5,
          4,
          3,
          2,
          1
        ]
      }
    ]
  },
  {
    "id": "rotting-oranges",
    "title": "Rotting Oranges",
    "difficulty": "Medium",
    "prompt": "You are given an m x n grid where each cell can have one of three values: - 0 representing an empty cell, - 1 representing a fresh orange, or - 2 representing a rotten orange. Every minute, any fresh orange that is 4-directionally adjacent to a rotten orange becomes rotten. Return the minimum number of minutes that must elapse until no cell has a fresh.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              2,
              1,
              1
            ],
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              1
            ]
          ]
        },
        "output": 4
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              2,
              1,
              1
            ],
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              1
            ]
          ]
        },
        "expected": 4
      }
    ]
  },
  {
    "id": "russian-doll-envelopes",
    "title": "Russian Doll Envelopes",
    "difficulty": "Hard",
    "prompt": "Given envelopes as [width, height], find max envelopes you can nest (both dimensions must be strictly.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "same-tree",
    "title": "Same Tree",
    "difficulty": "Easy",
    "prompt": "Given the roots of two binary trees p and q, determine if they are the same tree. Two binary trees are the same if they are structurally identical and have the same.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "search-insert-position",
    "title": "Search Insert Position",
    "difficulty": "Easy",
    "prompt": "Return index of target or where it would be inserted in sorted.",
    "category": "BinarySearch",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "search-insert-position"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "search-insert-position"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "sequential-grid-path-cover",
    "title": "Sequential Grid Path Cover",
    "difficulty": "Hard",
    "prompt": "You are given a 2D array grid of size m x n, and an integer k. There are k cells in grid containing the values from 1 to k exactly once, and the rest of the cells have a value 0. You can start at any cell, and move from a cell to its neighbors (up, down, left, or right). You must find a path in grid which: - Visits each cell in grid exactly once. - Visits.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "sequentially-ordinal-rank-tracker",
    "title": "Sequentially Ordinal Rank Tracker",
    "difficulty": "Hard",
    "prompt": "Track rankings with add() and get(). The ith call to get() returns the ith best.",
    "category": "SortedList",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "sequentially-ordinal-rank-tracker"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "sequentially-ordinal-rank-tracker"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "shortest-common-supersequence",
    "title": "Shortest Common Supersequence",
    "difficulty": "Hard",
    "prompt": "Given two strings str1 and str2, return the shortest string that has both as.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "shortest-common-supersequence"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "shortest-common-supersequence"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "shortest-distance-from-all-buildings",
    "title": "Shortest Distance from All Buildings",
    "difficulty": "Hard",
    "prompt": "You are given an m x n grid grid of values 0, 1, or 2, where: - each 0 marks an empty land that you can pass by freely, - each 1 marks a building that you cannot pass through, and - each 2 marks an obstacle that you cannot pass through. You want to build a house on an empty land that reaches all buildings in the shortest total travel distance. Return the.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "shortest-path-visiting-all-nodes",
    "title": "Shortest Path Visiting All Nodes",
    "difficulty": "Hard",
    "prompt": "You have an undirected, connected graph of n nodes labeled from 0 to n - 1. You are given an array graph where graph[i] is a list of all the nodes connected with node i by an edge. Return the length of the shortest path that visits every node. You may start and stop at any node, you may revisit nodes multiple times, and you may reuse.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "sliding-window-median",
    "title": "Sliding Window Median",
    "difficulty": "Hard",
    "prompt": "You are given an integer array nums and an integer k. There is a sliding window of size k which is moving from left to right. Return the median array for each.",
    "category": "Heap",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "smallest-common-region",
    "title": "Smallest Common Region",
    "difficulty": "Medium",
    "prompt": "Given region hierarchy lists (first region contains all others in its list), find the smallest region containing both region1 and.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "smallest-common-region"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "smallest-common-region"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "smallest-sufficient-team",
    "title": "Smallest Sufficient Team",
    "difficulty": "Hard",
    "prompt": "Given required skills and people with skills, find smallest team covering all.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "smallest-sufficient-team"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "smallest-sufficient-team"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "sort-an-array",
    "title": "Sort an Array",
    "difficulty": "Medium",
    "prompt": "Given an array of integers nums, sort the array in ascending order and return it. You must solve the problem without using any built-in functions in O(nlog(n)) time complexity and with the smallest space complexity.",
    "category": "DivideAndConquer",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "special-permutations",
    "title": "Special Permutations",
    "difficulty": "Medium",
    "prompt": "Count permutations where adjacent elements satisfy: nums[i] % nums[i+1] == 0 or nums[i+1] % nums[i] ==.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "split-array-largest-sum",
    "title": "Split Array Largest Sum",
    "difficulty": "Hard",
    "prompt": "Split array into k subarrays to minimize the maximum subarray.",
    "category": "BinarySearch",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "k",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "output": 5
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            3,
            2,
            1,
            5,
            6,
            4
          ],
          "k": 2
        },
        "expected": 5
      }
    ]
  },
  {
    "id": "stone-game-ii",
    "title": "Stone Game II",
    "difficulty": "Medium",
    "prompt": "Alice and Bob take turns taking 1 to 2M piles. M updates to max(M, X). Alice maximizes her.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "subarray-sums-divisible-by-k",
    "title": "Subarray Sums Divisible by K",
    "difficulty": "Medium",
    "prompt": "Solve Subarray Sums Divisible By K using the input model shown below. Return the requested value from solve(...).",
    "category": "ArraysAndHashing",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "goal",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            0,
            1,
            0,
            1
          ],
          "goal": 2
        },
        "output": 4
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            0,
            1,
            0,
            1
          ],
          "goal": 2
        },
        "expected": 4
      }
    ]
  },
  {
    "id": "subarrays-with-k-different-integers",
    "title": "Subarrays with K Different Integers",
    "difficulty": "Hard",
    "prompt": "Given an integer array nums and an integer k, return the number of good subarrays of nums. A good array is an array where the number of different integers in that array is exactly.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "subsets",
    "title": "Subsets",
    "difficulty": "Medium",
    "prompt": "Given a list of numbers, return a list of all subsets. Example: - Input: nums = [1,2,3] - Output: [[],[1],[2],[1,2],[3],[1,3],[2,3],[1,2,3]] We apply the template. The only difference is for subsets, their size is not always of length n. So we need to also try the case, where we don't use nums[i]. This enables us to get all the subsets of length < n. To.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2
          ]
        },
        "output": [
          [
            1,
            2
          ],
          [
            2,
            1
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2
          ]
        },
        "expected": [
          [
            1,
            2
          ],
          [
            2,
            1
          ]
        ]
      }
    ]
  },
  {
    "id": "subsets-ii",
    "title": "Subsets II",
    "difficulty": "Medium",
    "prompt": "Given an integer array nums that may contain duplicates, return all possible subsets (the power set). The solution set must not contain duplicate subsets. Return the solution in any.",
    "category": "Backtracking",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2
          ]
        },
        "output": [
          [
            1,
            2
          ],
          [
            2,
            1
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2
          ]
        },
        "expected": [
          [
            1,
            2
          ],
          [
            2,
            1
          ]
        ]
      }
    ]
  },
  {
    "id": "substrings-of-size-three-with-distinct-characters",
    "title": "Substrings of Size Three with Distinct Characters",
    "difficulty": "Easy",
    "prompt": "A string is good if there are no repeated characters. Given a string s, return the number of good substrings of length three in.",
    "category": "SlidingWindow",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "subtree-inversion-sum",
    "title": "Subtree Inversion Sum",
    "difficulty": "Hard",
    "prompt": "Maximize tree sum by inverting subtrees (multiply by -1), with min distance k between.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "sum-of-distances-in-tree",
    "title": "Sum of Distances in Tree",
    "difficulty": "Hard",
    "prompt": "Return array where answer[i] is sum of distances from node i to all other.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "sum-of-subarray-minimums",
    "title": "Sum of Subarray Minimums",
    "difficulty": "Medium",
    "prompt": "Solve Sum Of Subarray Minimums using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "sum-of-subarray-ranges",
    "title": "Sum of Subarray Ranges",
    "difficulty": "Medium",
    "prompt": "Solve Sum Of Subarray Ranges using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "sum-of-total-strength-of-wizards",
    "title": "Sum of Total Strength of Wizards",
    "difficulty": "Hard",
    "prompt": "Solve Sum Of Total Strength Of Wizards using the input model shown below. Return the requested value from solve(...).",
    "category": "MonotonicStack",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "sum-root-to-leaf-numbers",
    "title": "Sum Root to Leaf Numbers",
    "difficulty": "Medium",
    "prompt": "Given a binary tree containing digits from 0 to 9 only, where each root-to-leaf path represents a number (e.g., 1 -> 2 -> 3 = 123), return the total sum of all root-to-leaf.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "surrounded-regions",
    "title": "Surrounded Regions",
    "difficulty": "Medium",
    "prompt": "You are given an m x n matrix board containing letters 'X' and 'O', capture regions that are surrounded: - Connect: A cell is connected to adjacent cells horizontally or vertically. - Region: To form a region connect every 'O' cell. - Surround: The region is surrounded with 'X' cells if you can connect the region with 'X' cells and none of the region cells.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "surrounded-regions"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "surrounded-regions"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "symmetric-tree",
    "title": "Symmetric Tree",
    "difficulty": "Easy",
    "prompt": "Given the root of a binary tree, check if it is a mirror of itself (symmetric around its.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "the-maze",
    "title": "The Maze",
    "difficulty": "Medium",
    "prompt": "There is a ball in a maze with empty spaces (represented as 0) and walls (represented as 1). The ball can go through the empty spaces by rolling up, down, left or right, but it won't stop rolling until hitting a wall. When the ball stops, it could choose the next direction. Given the m x n maze, the ball's start position and the destination, return true if.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "the-maze-ii",
    "title": "The Maze II",
    "difficulty": "Medium",
    "prompt": "There is a ball in a maze with empty spaces (represented as 0) and walls (represented as 1). The ball can go through the empty spaces by rolling up, down, left or right, but it won't stop rolling until hitting a wall. When the ball stops, it could choose the next direction. Given the m x n maze, the ball's start position and the destination, return the.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "the-number-of-weak-characters-in-the-game",
    "title": "The Number of Weak Characters in the Game",
    "difficulty": "Medium",
    "prompt": "Count characters where both attack and defense are strictly less than another.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "the-number-of-weak-characters-in-the-game"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "the-number-of-weak-characters-in-the-game"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "the-skyline-problem",
    "title": "The Skyline Problem",
    "difficulty": "Hard",
    "prompt": "Given the coordinates of buildings as triplets [left, right, height], return the key points of the skyline formed by these buildings. Example: - Input: buildings = [[2,9,10],[3,7,15],[5,12,12],[15,20,10],[19,24,8]] - Output:.",
    "category": "Interval",
    "signature": {
      "args": [
        {
          "name": "buildings",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "buildings": [
            [
              2,
              9,
              10
            ],
            [
              3,
              7,
              15
            ],
            [
              5,
              12,
              12
            ],
            [
              15,
              20,
              10
            ],
            [
              19,
              24,
              8
            ]
          ]
        },
        "output": [
          [
            2,
            10
          ],
          [
            3,
            15
          ],
          [
            7,
            12
          ],
          [
            12,
            0
          ],
          [
            15,
            10
          ],
          [
            20,
            8
          ],
          [
            24,
            0
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "buildings": [
            [
              2,
              9,
              10
            ],
            [
              3,
              7,
              15
            ],
            [
              5,
              12,
              12
            ],
            [
              15,
              20,
              10
            ],
            [
              19,
              24,
              8
            ]
          ]
        },
        "expected": [
          [
            2,
            10
          ],
          [
            3,
            15
          ],
          [
            7,
            12
          ],
          [
            12,
            0
          ],
          [
            15,
            10
          ],
          [
            20,
            8
          ],
          [
            24,
            0
          ]
        ]
      }
    ]
  },
  {
    "id": "top-k-frequent-words",
    "title": "Top K Frequent Words",
    "difficulty": "Medium",
    "prompt": "Given an array of strings words and an integer k, return the k most frequent strings. Return the answer sorted by the frequency from highest to lowest. Sort the words with the same frequency by their lexicographical.",
    "category": "Heap",
    "signature": {
      "args": [
        {
          "name": "words",
          "type": "stringArray"
        },
        {
          "name": "k",
          "type": "int"
        }
      ],
      "returns": "stringArray"
    },
    "examples": [
      {
        "input": {
          "words": [
            "i",
            "love",
            "leetcode",
            "i",
            "love",
            "coding"
          ],
          "k": 2
        },
        "output": [
          "i",
          "love"
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "words": [
            "i",
            "love",
            "leetcode",
            "i",
            "love",
            "coding"
          ],
          "k": 2
        },
        "expected": [
          "i",
          "love"
        ]
      }
    ]
  },
  {
    "id": "trapping-rain-water-ii",
    "title": "Trapping Rain Water II",
    "difficulty": "Hard",
    "prompt": "Given an m x n integer matrix heightMap representing the height of each unit cell in a 2D elevation map, return the volume of water it can trap after.",
    "category": "Graph",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "trapping-rain-water-ii"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "trapping-rain-water-ii"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "two-best-non-overlapping-events",
    "title": "Two Best Non-Overlapping Events",
    "difficulty": "Medium",
    "prompt": "Attend at most 2 non-overlapping events to maximize total.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "intervals",
          "type": "intMatrix"
        }
      ],
      "returns": "intMatrix"
    },
    "examples": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "output": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "intervals": [
            [
              1,
              3
            ],
            [
              2,
              6
            ],
            [
              8,
              10
            ]
          ]
        },
        "expected": [
          [
            1,
            6
          ],
          [
            8,
            10
          ]
        ]
      }
    ]
  },
  {
    "id": "two-sum-less-than-k",
    "title": "Two Sum Less Than K",
    "difficulty": "Easy",
    "prompt": "Given an array nums of integers and integer k, return the maximum sum such that there exists i < j with nums[i] + nums[j] = sum and sum <.",
    "category": "TwoPointer",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        },
        {
          "name": "target",
          "type": "int"
        }
      ],
      "returns": "intArray"
    },
    "examples": [
      {
        "input": {
          "nums": [
            2,
            7,
            11,
            15
          ],
          "target": 9
        },
        "output": [
          0,
          1
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            2,
            7,
            11,
            15
          ],
          "target": 9
        },
        "expected": [
          0,
          1
        ]
      }
    ]
  },
  {
    "id": "unique-binary-search-trees",
    "title": "Unique Binary Search Trees",
    "difficulty": "Medium",
    "prompt": "Count structurally unique BSTs with values 1 to.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "n",
          "type": "int"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "n": 3
        },
        "output": 5
      }
    ],
    "tests": [
      {
        "input": {
          "n": 3
        },
        "expected": 5
      }
    ]
  },
  {
    "id": "unique-binary-search-trees-ii",
    "title": "Unique Binary Search Trees II",
    "difficulty": "Medium",
    "prompt": "Generate all structurally unique BSTs with values 1 to.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "n",
          "type": "int"
        }
      ],
      "returns": "stringArray"
    },
    "examples": [
      {
        "input": {
          "n": 3
        },
        "output": [
          "1,#,2,#,3",
          "1,#,3,2",
          "2,1,3",
          "3,1,#,#,2",
          "3,2,#,1"
        ]
      }
    ],
    "tests": [
      {
        "input": {
          "n": 3
        },
        "expected": [
          "1,#,2,#,3",
          "1,#,3,2",
          "2,1,3",
          "3,1,#,#,2",
          "3,2,#,1"
        ]
      }
    ]
  },
  {
    "id": "unique-paths",
    "title": "Unique Paths",
    "difficulty": "Medium",
    "prompt": "Count paths from top-left to bottom-right, moving only right or.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "unique-paths-ii",
    "title": "Unique Paths II",
    "difficulty": "Medium",
    "prompt": "Same as Unique Paths but with obstacles (marked as.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "grid",
          "type": "intMatrix"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "grid": [
            [
              1,
              1,
              0
            ],
            [
              0,
              1,
              0
            ],
            [
              1,
              0,
              1
            ]
          ]
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "unit-conversion-i",
    "title": "Unit Conversion I",
    "difficulty": "Medium",
    "prompt": "Given unit conversion graph, find conversion rate from unit 0 to all other.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "unit-conversion-i"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "unit-conversion-i"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "unit-conversion-ii",
    "title": "Unit Conversion II",
    "difficulty": "Medium",
    "prompt": "Convert between any two units in conversion.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "input",
          "type": "string"
        }
      ],
      "returns": "string"
    },
    "examples": [
      {
        "input": {
          "input": "unit-conversion-ii"
        },
        "output": "ok"
      }
    ],
    "tests": [
      {
        "input": {
          "input": "unit-conversion-ii"
        },
        "expected": "ok"
      }
    ]
  },
  {
    "id": "valid-palindrome-ii",
    "title": "Valid Palindrome II",
    "difficulty": "Easy",
    "prompt": "Given a string s, return true if the s can be palindrome after deleting at most one character from.",
    "category": "Palindrome",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "bool"
    },
    "examples": [
      {
        "input": {
          "s": "abca"
        },
        "output": true
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abca"
        },
        "expected": true
      }
    ]
  },
  {
    "id": "valid-palindrome-iii",
    "title": "Valid Palindrome III",
    "difficulty": "Hard",
    "prompt": "Return true if string can become palindrome by removing at most k.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "bool"
    },
    "examples": [
      {
        "input": {
          "s": "abca"
        },
        "output": true
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abca"
        },
        "expected": true
      }
    ]
  },
  {
    "id": "valid-palindrome-iv",
    "title": "Valid Palindrome IV",
    "difficulty": "Medium",
    "prompt": "You are given a 0-indexed string s consisting of only lowercase English letters. In one operation, you can change any character of s to any other character. Return true if you can make s a palindrome after performing exactly one or two operations, or return false.",
    "category": "Palindrome",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "valid-parenthesis-string",
    "title": "Valid Parenthesis String",
    "difficulty": "Medium",
    "prompt": "Given string with '(', ')', and '*' (wildcard), determine if it can be.",
    "category": "Parenthesis",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  },
  {
    "id": "valid-triangle-number",
    "title": "Valid Triangle Number",
    "difficulty": "Medium",
    "prompt": "Given an array of integers, return the number of all triplets where they can form the edges of a.",
    "category": "TwoPointer",
    "signature": {
      "args": [
        {
          "name": "nums",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "output": 10
      }
    ],
    "tests": [
      {
        "input": {
          "nums": [
            1,
            2,
            3,
            4
          ]
        },
        "expected": 10
      }
    ]
  },
  {
    "id": "validate-binary-search-tree",
    "title": "Validate Binary Search Tree",
    "difficulty": "Medium",
    "prompt": "Determine if a binary tree is a valid binary search tree.",
    "category": "Tree",
    "signature": {
      "args": [
        {
          "name": "root",
          "type": "intArray"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "output": 6
      }
    ],
    "tests": [
      {
        "input": {
          "root": [
            1,
            2,
            3
          ]
        },
        "expected": 6
      }
    ]
  },
  {
    "id": "wildcard-matching",
    "title": "Wildcard Matching",
    "difficulty": "Hard",
    "prompt": "Match string s with pattern p where '?' matches any single char, '*' matches any.",
    "category": "DynamicProgramming",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        },
        {
          "name": "p",
          "type": "string"
        }
      ],
      "returns": "bool"
    },
    "examples": [
      {
        "input": {
          "s": "adceb",
          "p": "*a*b"
        },
        "output": true
      }
    ],
    "tests": [
      {
        "input": {
          "s": "adceb",
          "p": "*a*b"
        },
        "expected": true
      }
    ]
  },
  {
    "id": "words-within-two-edits-of-dictionary",
    "title": "Words Within Two Edits of Dictionary",
    "difficulty": "Medium",
    "prompt": "You are given two string arrays, queries and dictionary. All words in each array comprise of lowercase English letters and have the same length. In one edit you can take a word from queries, and change any letter in it to any other letter. Find all words from queries that, after a maximum of two edits, equal some word from dictionary. Return a list of all.",
    "category": "Trie",
    "signature": {
      "args": [
        {
          "name": "s",
          "type": "string"
        }
      ],
      "returns": "int"
    },
    "examples": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "output": 3
      }
    ],
    "tests": [
      {
        "input": {
          "s": "abcabcbb"
        },
        "expected": 3
      }
    ]
  }
];

export default courseProblems;
